"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ArcTransfer(props) {
  var data = props.data,
    titles = props.titles,
    targetKeys = props.targetKeys,
    displayKey = props.displayKey,
    disabled = props.disabled,
    oneWay = props.oneWay,
    showSearch = props.showSearch,
    selectedKeys = props.selectedKeys,
    onChange = props.onChange,
    onSelectChange = props.onSelectChange,
    pagination = props.pagination,
    onScroll = props.onScroll;
  var key = displayKey ? displayKey : 'value';

  // removed filetr 
  return /*#__PURE__*/_react["default"].createElement(_lib.Transfer, _extends({}, props, {
    dataSource: data,
    showSearch: showSearch,
    titles: titles ? titles : ['Source', 'Target'],
    targetKeys: targetKeys,
    selectedKeys: selectedKeys,
    disabled: disabled,
    onChange: onChange,
    onSelectChange: onSelectChange,
    onScroll: onScroll,
    render: function render(item) {
      return item[key];
    },
    oneWay: oneWay,
    pagination: pagination
  }));
}
var _default = ArcTransfer;
exports["default"] = _default;